var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLinkedin = function SvgLinkedin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "LinkedIn")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.92,19.56c0-.37,0-.74,0-1.11s0-.6,0-.89c0-.94,0-1.87,0-2.81s0-1.62,0-2.43c0-1,0-2,0-3,0-.71,0-1.43,0-2.14,0-.15,0-.3,0-.45s0-.11.11-.11h4c.15,0,.15,0,.15.15V8.47c0-.06.06-.09.08-.13A4.56,4.56,0,0,1,12.8,6.92a4.17,4.17,0,0,1,1.56-.52,5.31,5.31,0,0,1,2.41.2,4.4,4.4,0,0,1,2.72,2.56A6.74,6.74,0,0,1,20,11c0,.18,0,.36.05.54v7.9c0,.07,0,.09-.09.09h-4.2V14.43c0-.71,0-1.42,0-2.14a4.1,4.1,0,0,0-.16-1,2.06,2.06,0,0,0-.71-1.11,2.29,2.29,0,0,0-3.15.62,2.58,2.58,0,0,0-.46,1.57V19.4c0,.05,0,.1,0,.16Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.26,19.56s0-.09,0-.14V6.74c0-.06,0-.09.09-.08H4.41c.14,0,.14,0,.14.14V19.44a.49.49,0,0,1,0,.12Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.43,4.92A2.47,2.47,0,0,1,1,4.53,2.08,2.08,0,0,1,0,2.74,2.1,2.1,0,0,1,.44,1.33,2.28,2.28,0,0,1,2,.47,3,3,0,0,1,3.35.58,2.17,2.17,0,0,1,4.82,2.37a2.27,2.27,0,0,1-.19,1.31A2.2,2.2,0,0,1,3.05,4.86,3.59,3.59,0,0,1,2.43,4.92Z",
    fill: "currentColor"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkedin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkedin.01b02eef.svg";
export { ForwardRef as ReactComponent };